import "react-sliding-pane/dist/react-sliding-pane.css";

import { CancelButton, SaveButton } from "../../elements/ActionButtons/index";
import { Col, FormGroup, Grid, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";

import Button from "../../elements/CustomButton/CustomButton";
import Card from "../Card/Card";
import ClientActionButton from "./ClientActionButton";
import ClientFormBilling from "./ClientFormBilling";
import ClientFormCommercial from "./ClientFormCommercial";
import ClientFormInfos from "./ClientFormInfos";
import ClientFormMoreInfos from "./ClientFormMoreInfos";
import ContactCards from "../Contact/ContactCards";
import Modal from "react-modal";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import React from "react";
import SlidingPane from "react-sliding-pane";
import SuperpositionHeader from "../Header/SuperpositionHeader";
import TaxParamsCard from "../Tax/TaxParamsCard";
import TiersXtraDataCard from "../Tiers/tiersXtraDataCard";
import { viewPortDimension } from "../../tools/viewportDimension";
import { withRouter } from "react-router-dom";

class ClientForm extends React.Component {
  constructor(props) {
    super(props);

    // console.log("29 - ClientForm constructor props", this.props);

    const country =
      (this.props.companyDefaultInfos.company &&
        this.props.companyDefaultInfos.company.addresses &&
        this.props.companyDefaultInfos.company.addresses[0].country) ||
      props.defaultCountry;

    this.INITIAL_STATE = {
      contacts: [
        {
          email: "",
          name: "",
          telFixe: "",
          telMobile: "",
          job: ""
        }
      ],
      numeroTVA: "",
      codeAPE: "",
      siret: "",
      defaultTermDelaisPaiement: "COMPTANT",
      defaultTermNetsFinDeMois: "NETS",
      name: this.props.inputName || "",
      website: "",
      address: "",
      zipCode: "",
      city: "",
      country: (country && country.id) || "",
      countryLabel: (country && country.label) || "FR",
      defaultTaxValue: 0.0,
      taxIdemCompany: this.props.client ? this.props.taxIdemCompany : true,
      tax1: this.props.companyDefaultInfos.company.tax1,
      tax2: this.props.companyDefaultInfos.company.tax2,
      taxableValue: this.props.client ? this.props.client.taxableValue : null,
      externalCodeValue: this.props.client ? this.props.client.externalCodeValue : "",
      escomptePercentValue: this.props.client ? this.props.client.escomptePercentValue : "0.0",
      iban: "",
      swift: "",
      relanceAuto: true,
      // TODO: use dynamic value!
      dateLanguage: this.props.client ? this.props.client.dateLanguage : null,
      language:
        country.label === "FR"
          ? this.props.companyDefaultInfos.language.id
          : this.props.companyDefaultInfos.languageEN.id,
      currency:
        this.props.companyDefaultInfos.company.currency &&
        this.props.companyDefaultInfos.company.currency.id,
      group: "",
      isPaneOpen: false,
      collaboratorRespCom: this.props.client
        ? this.props.client.collaboratorRespCom
        : null
    };

    this.state = props.client ? props.client : this.INITIAL_STATE;

    this.state.taxableValue = props.client && props.client.taxableValue ? props.client.taxableValue : "ENCAISSEMENT";
    this.state.externalCodeValue = props.client && props.client.externalCodeValue ? props.client.externalCodeValue : "";
    this.state.escomptePercentValue = props.client && props.client.escomptePercentValue ? props.client.escomptePercentValue : "0.0";

    this.state.tiersRespCom =
      this.state.collaboratorRespCom && this.state.collaboratorRespCom.tiers
        ? {
          label: this.state.collaboratorRespCom.tiers.name,
          value: this.state.collaboratorRespCom.tiers.id,
          tiers: this.state.collaboratorRespCom.tiers
        }
        : null;

    this.state.isPaneOpen = false;
    console.log(this.props.delete);
  }

  addLine() {
    let contacts = this.state.contacts;
    contacts = [
      ...contacts,
      {
        email: "",
        name: "",
        telFixe: "",
        telMobile: "",
        job: ""
      }
    ];
    this.setState({ contacts });
  }
  removeLine(lineIndex) {
    const contacts = this.state.contacts;
    contacts.splice(lineIndex, 1);
    this.setState({ contacts });
  }
  updateLineValue(lineIndex, key, value) {
    let contacts = this.state.contacts;
    contacts[lineIndex][key] = value;
    this.setState({ contacts });
  }
  updateFormValue = (key, target) => {
    console.log("updateFormValue", key, target);
    const newState = {
      [key]: target ? target.value : ""
    };

    this.setState(newState);
  };
  onCancel() {
    this.setState(this.props.client ? this.props.client : this.INITIAL_STATE);
  }
  onSubmit() {
    if (this.state && this.state.name === "") return;

    this.props.onSubmit(this.state);
  }
  handleOnSelected = value => {
    console.log("handleOnSelected", value);
    const { name, address, ape, countryCode, siret } = value.company;
    this.setState({ name, address, siret, countryCode, codeAPE: ape });
  };

  showDeleteSlidingPane = () => {
    this.setState({
      isPaneOpen: true,
      paneTitleIds: this.props.intl.formatMessage({
        id: "ids_clientDeletion"
      }),
      paneContentIds: this.props.intl.formatMessage({
        id: "ids_confirmDeleteClient"
      }),
      ids_paneActionSuccess: this.props.intl.formatMessage({
        id: "ids_clientHasBeenDeleted"
      }),
      ids_paneActionFailed: this.props.intl.formatMessage({
        id: "ids_errorClientCouldNotBeDeleted"
      }),

      paneConfirmAction: async () => {
        return await this.props.deleteClient();
      }
    });
  };

  onPaneConfirm = async event => {
    console.log("OnPaneConfirm 001");

    this.setState({ actionRunning: true });

    let bTest = await this.state.paneConfirmAction(event);

    if (
      bTest &&
      bTest.data &&
      bTest.data.deleteTiersAfterCheck &&
      bTest.data.deleteTiersAfterCheck.result
    ) {
      this.setState({ actionRunning: false });

      let notif = NotificationProvider.getSuccessNotification();
      notif.message = this.state.ids_paneActionSuccess;
      this.props.sendNotification(notif);

      this.setState({ isPaneOpen: false });
      setTimeout(() => {
        this.props.history.push("/clients");
      }, 1500);
    } else {
      let notif = NotificationProvider.getFailureNotification();
      notif.message = this.state.ids_paneActionFailed;

      this.setState({ isPaneOpen: false });
      this.props.sendNotification(notif);
    }
  };

  componentDidMount() {
    Modal.setAppElement(this.el);
  }
  renderActionButton() {
    return (
      <ClientActionButton
        availableActions={["DELETECLIENT"]}
        deleteClient={() => {
          console.log("call showDeleteClientSlidingPane", this);
          this.showDeleteSlidingPane();
        }}
      />
    );
  }

  renderHeader(backBtnText, client) {
    if (!this.props.inSideModal) {

      console.log("213 - ", this.props.checkDelete);
      const hideDeleteButton = this.props.checkDelete === undefined ? false : (
        this.props.checkDelete.loading ||
        this.props.checkDelete.checkOnlyDeleteTiers.result === false
      );
      return (
        <SuperpositionHeader
          backBtnText={backBtnText}
          handleMinimizeSidebar={this.props.handleMinimizeSidebar}
        >
          <div className="space-between">
            <div>{(!client || hideDeleteButton) ? <div /> : this.renderActionButton()}</div>
            {/* <CancelButton onClick={() => this.onCancel()} /> */}
            <SaveButton
              onClick={() => this.onSubmit()}
              className="btn-fill pull-right margin-left-20"
            />
          </div>
        </SuperpositionHeader>
      );
    }
    return <div />;
  }

  renderButton() {
    if (this.props.inSideModal) {
      return (
        <div className="side-modal-footer">
          <CancelButton onClick={this.props.cancel} />
          <SaveButton
            onClick={() => this.onSubmit()}
            className="btn-fill pull-right margin-left-20"
          />
        </div>
      );
    }
    return <div />;
  }

  renderForm(address) {
    // console.log("261 - ClientForm render", this.state);
    // console.log("263 - ClientForm render", this.props);

    return (
      <FormGroup>
        <Row>
          <Col sm={6}>
            <ClientFormInfos
              updateFormValue={this.updateFormValue.bind(this)}
              name={this.state.name}
              address={address}
              country={this.state.country}
              handleOnSelected={this.handleOnSelected}
            />
          </Col>
          <Col sm={6}>
            <ClientFormMoreInfos
              updateFormValue={this.updateFormValue.bind(this)}
              website={this.state.website}
              siret={this.state.siret}
              numeroTVA={this.state.numeroTVA}
              codeAPE={this.state.codeAPE}
              group={this.state.group}
            />
          </Col>
        </Row>
        <ClientFormBilling
          companyId={this.props.companyId}
          updateFormValue={this.updateFormValue.bind(this)}
          // defaultTaxValue={this.state.tax}
          tax={this.state.tax}
          defaultTermDelaisPaiement={this.state.defaultTermDelaisPaiement}
          defaultTermNetsFinDeMois={this.state.defaultTermNetsFinDeMois}
          relanceAuto={this.state.relanceAuto}
          language={this.state.language}
          dateLanguage={this.state.dateLanguage}
          currency={this.state.currency}
          iban={this.state.iban}
          swift={this.state.swift}
          companyTaxBase={this.props.companyTax}
        />
        <Row>
          <Col sm={6}>
            <ClientFormCommercial
              companyDefaultInfos={this.props.companyDefaultInfos}
              sendNotification={this.props.sendNotification}
              companyId={this.props.companyId}
              tiersRespCom={this.state.tiersRespCom}
              updateValue={
                // collab => this.setState({ collaboratorRespCom: collab })
                this.updateFormValue
              }
            />
          </Col>
        </Row>
      </FormGroup>
    );
  }

  renderFormContainer(address) {
    // console.log("tAX1:", this.state.tax1);
    // console.log("tAX2:", this.state.tax2);
    if (this.props.inSideModal) {
      return (
        <div>
          {this.renderForm(address)}
          <TaxParamsCard
            blockCreateOnTaxes={this.props.inSideModal}
            companyId={this.props.companyId}
            tax1={this.state.tax1}
            tax2={this.state.tax2}
            sendNotification={this.props.sendNotification}
            onChange={(key, value) => {
              this.setState({ [key]: value });
            }}
            withIdemCheckBox
            taxIdemCompany={this.state.taxIdemCompany}
            taxableValue={this.state.taxableValue}
            intl={this.props.intl}
          />

          <TiersXtraDataCard
            taxableValue={this.state.taxableValue}
            externalCodeValue={this.state.externalCodeValue}
            escomptePercentValue={this.state.escomptePercentValue}
            companyId={this.props.companyId}
            onChange={(key, value) => this.setState({ [key]: value })}
            intl={this.props.intl}
          />

          <ContactCards
            lines={this.state.contacts}
            country={this.state.countryLabel}
            updateLineValue={this.updateLineValue.bind(this)}
            removeLine={this.removeLine.bind(this)}
            addLine={this.addLine.bind(this)}
          />
        </div>
      );
    }

    return (
      <div className="main-content">
        <Grid fluid>
          <div className="main-content">
            <Row>
              <Card>{this.renderForm(address)}</Card>
              <TaxParamsCard
                companyId={this.props.companyId}
                tax1={this.state.tax1}
                tax2={this.state.tax2}
                sendNotification={this.props.sendNotification}
                onChange={(key, value) => this.setState({ [key]: value })}
                withIdemCheckBox
                taxIdemCompany={this.state.taxIdemCompany}
                taxableValue={this.state.taxableValue}
                intl={this.props.intl}
              />

              <TiersXtraDataCard
                taxableValue={this.state.taxableValue}
                externalCodeValue={this.state.externalCodeValue}
                escomptePercentValue={this.state.escomptePercentValue}
                companyId={this.props.companyId}
                onChange={(key, value) => this.setState({ [key]: value })}
                intl={this.props.intl}
              />

              <ContactCards
                lines={this.state.contacts}
                country={this.state.countryLabel}
                updateLineValue={this.updateLineValue.bind(this)}
                removeLine={this.removeLine.bind(this)}
                addLine={this.addLine.bind(this)}
              />
            </Row>
          </div>
        </Grid>
      </div>
    );
  }

  render() {
    // console.log("367 - checkDelete=", this.props.checkDelete);
    // console.log("ClientForm render", this.props, this.state);

    let { intl, client } = this.props;
    let address = this.state.address && this.state.address.replace("\\n", "\n");
    let backBtnText = !client
      ? intl.formatMessage({ id: "ids_newClient" })
      : client.name || intl.formatMessage({ id: "ids_edit" });

    const dimension = viewPortDimension();
    const slidingPaneWidth =
      Math.min(dimension.width - 200, 800).toString() + "px";

    return (
      <div ref={ref => (this.el = ref)}>
        <SlidingPane
          overlayClassName="some-custom-overlay-class"
          isOpen={this.state.isPaneOpen}
          title={this.state.paneTitleIds}
          width={slidingPaneWidth}
          onRequestClose={() => this.setState({ isPaneOpen: false })}
        >
          <div>
            <p>{this.state.paneContentIds}</p>
            <FormGroup>
              <CancelButton
                onClick={() => this.setState({ isPaneOpen: false })}
              />
              <Button
                icon
                fill
                wd
                bsStyle="primary"
                onClick={event => this.onPaneConfirm(event)}
              >
                <i className="fa fa-lg fa-check" />
                <FormattedMessage id="ids_confirm" />
              </Button>
            </FormGroup>
          </div>
        </SlidingPane>

        {this.renderHeader(backBtnText, client)}
        <Grid fluid>
          {this.renderFormContainer(address)}
          {this.renderButton()}
        </Grid>
      </div>
    );
  }
}

export default withRouter(injectIntl(ClientForm));
